import { XMLState } from "./XMLState.js";
import { XMLDiff } from "./XMLDiff.js";

export class VROC {
	constructor() {
		this.components = new Map(); // Хранилище компонентов: { id -> { state, template, container } }
		this.xsltCache = new Map();  // Кеш XSLT-шаблонов
		this.diff = new XMLDiff({ 
			uniqueTags: ['module', 'pages', 'items'] 
		});   // Инструмент сравнения XML
	}

	// Сценарий 1: Динамическая загрузка компонента
	async loadComponent(options) {
		let { id, xmlUrl, templateId, node } = options;
		node = $(node)[0];
		
		// Загрузка данных
		const xmlResponse = await fetch(xmlUrl);
		const xmlText = await xmlResponse.text();
		
		// Создание компонента
		const component = {
			state: new XMLState(xmlText),
			templateId,
			container: node,
			domMap: new Map()
		};
		
		this.components.set(id, component);
		
		// Первоначальный рендеринг
		await this.renderFragment(id, node, new DOMParser().parseFromString(xmlText, "text/xml"));
		
		return id;
	}

	// Сценарий 2: Привязка к существующему DOM-элементу
	attachComponent(options) {
		let { id, xmlUrl, templateId, node } = options;
		node = $(node)[0];
		
		const component = {
			state: null,
			templateId,
			container: node,
			domMap: new Map()
		};
		
		// Асинхронная загрузка данных
		if (xmlUrl) {
			fetch(xmlUrl)
				.then(r => r.text())
				.then(xml => {
					component.state = new XMLState(xml);
					//this.renderFragment(id);
				});
		}
		
		this.components.set(id, component);
		return id;
	}

	// Обновление компонента
	async updateComponent(id, newXml) {
		const component = this.components.get(id);
		if (!component) return;

		const oldXml = component.state.serialize();
		component.state.update(newXml);
		
		const patches = this.diff.calculatePatch(oldXml, newXml);
		this.applyPatch(id, patches);
	}

	async loadVROC(url, tpl, el) {
		const response = await fetch(url);
		const initXml = await response.text();
		
		window.state = new XMLState(initXml);
		window.lastXML = initXml;

		await this.renderFragment(tpl, el, window.state.doc);
		this.buildDomMap(container);
	}

	buildDomMap(root = document) {
	  root.querySelectorAll('[data-xpath]').forEach(el => {
		this.domMap.set(el.dataset.xpath, el);
	  });
	}

	updateDomMap() {
	  this.domMap.clear();
	  this.buildDomMap();
	}

	async renderFragment(id, target, xmlData, patches) {
		const component = this.components.get(id);
		if (!component) return;

		const xslt = await this._getTemplate(component.templateId);

		if(patches) {
			const markerStylesheet = `<?xml version="1.0"?>
				<xsl:stylesheet version="1.0" xmlns:xsl="http://www.w3.org/1999/XSL/Transform">
					<xsl:template match="*">
						<xsl:copy>
							<xsl:attribute name="data-diff-marker">true</xsl:attribute>
							<xsl:apply-templates select="@*|node()"/>
						</xsl:copy>
					</xsl:template>
				</xsl:stylesheet>
			`;
			
			const markerProcessor = new XSLTProcessor();
			markerProcessor.importStylesheet(
				new DOMParser().parseFromString(markerStylesheet, "text/xml")
			);
			
			xmlData = markerProcessor.transformToDocument(xmlData);
		}

		const processor = new XSLTProcessor();
		processor.importStylesheet(xslt);
		
		// Добавляем корневой элемент если его нет
		const wrappedXml = xmlData.documentElement.nodeName === 'module' 
			? xmlData 
			: new DOMParser().parseFromString(
				`<module>${new XMLSerializer().serializeToString(xmlData)}</module>`,
				"text/xml"
			);
		
		const fragment = processor.transformToFragment(wrappedXml, document);
		
		
		// Очищаем временный корневой элемент
		const rootNode = fragment.firstElementChild?.nodeName === 'MODULE' 
			? fragment.firstElementChild
			: fragment;
			
		target.replaceChildren(...rootNode.childNodes);
		
		// Построение карты DOM
		this._buildDomMap(id);
	}

	async _getTemplate(templateId) {
		if (!this.xsltCache.has(templateId)) {
			const response = await fetch(`/vroc/${templateId}.xsl`);
			const xsltText = await response.text();
			this.xsltCache.set(templateId, 
				new DOMParser().parseFromString(xsltText, "text/xml")
			);
		}
		return this.xsltCache.get(templateId);
	}

	_buildDomMap(id) {
		const component = this.components.get(id);
		component.domMap.clear();
		
		component.container.querySelectorAll('[data-xpath]').forEach(el => {
			component.domMap.set(el.dataset.xpath, el);
		});
	}

	// Пока отключим - нужно думать, будет ли какая-то структура, нужно обсуждать
	/*
	_applyDataBindings(element) {
		element.querySelectorAll('[id]').forEach(el => {
			const xpath = this._generateXPath(el);
			el.dataset.xpath = xpath;
		});
	}

	_generateXPath(element) {
		const path = [];
		let current = element;
		
		while(current && current.nodeType === Node.ELEMENT_NODE) {
			let selector = current.tagName.toLowerCase();
			
			if(current.id) {
				selector += `[@id='${current.id}']`;
			} else {
				const siblings = Array.from(current.parentNode.children)
					.filter(n => n.tagName === current.tagName);
				if(siblings.length > 1) {
					selector += `[${siblings.indexOf(current) + 1}]`;
				}
			}
			
			path.unshift(selector);
			current = current.parentNode;
		}
		
		return '/' + path.join('/');
	}
	*/

	async applyPatch(id, patches) {
		const component = this.components.get(id);
		if (!component) return;

		const { state, templateId, container } = component;

		const serializer = new XMLSerializer();

		const clonedXml = new DOMParser().parseFromString(
			new XMLSerializer().serializeToString(state.doc),
			"text/xml"
		);

		// Обрабатываем каждый патч
		for (const patch of patches) {
			//console.log('Processing patch:', patch); // Логирование каждого патча
			const nodes = container.querySelectorAll(`[data-xpath="${patch.xpath}"]`);
			
			switch(patch.action) {
				case 'add':
					// Создаём временный контейнер
					const tempDiv = document.createElement('div');
					
					// Создаём XML с новыми данными, учитывая data-xpath
					const addXml = this._createXmlFromXPath(patch.xpath, patch.value, clonedXml);
					
					// Применяем XSLT-преобразование к новым данным
					await this.renderFragment(
						id,
						tempDiv,
						new DOMParser().parseFromString(addXml, "text/xml")
					);

					// Вставляем обработанные узлы
					const target = document.querySelector(`[data-xpath="${patch.xpath}"]`);
					const tempNode = tempDiv.querySelector(`[data-xpath="${patch.xpath}"]`);
					
					if (target && tempNode) {
						const newRows = [...tempNode.childNodes]; // Преобразуем NodeList в массив

						// Добавляем строки в таблицу
						target.append(...newRows);

						// Добавляем класс с анимацией к каждой новой строке
						//newRows.forEach(row => row.classList.add('fade-in'));
					}
					break;
					
				case 'remove':
					nodes.forEach(node => node.remove());
					break;
				
				case 'update-text':
				case 'update-attr':
					// Для update-text делаем XSLT-трансформацию и обновляем целый блок
					const tempDivText = document.createElement('div');
					let updateXml;

					// Создаём XML с новым значением, учитывая data-xpath
					if (patch.action == 'update-text')
						updateXml = this._createXmlFromXPath(patch.xpath, patch.value, clonedXml);
					else
						updateXml = patch.value;
					//console.log(updateXml);
					
					// Применяем XSLT-преобразование
					await this.renderFragment(
						id,
						tempDivText,
						new DOMParser().parseFromString(updateXml, "text/xml")
					);
					
					// Находим целевой узел и заменяем его содержимое
					const targetText = container.querySelector(`[data-xpath="${patch.xpath}"]`);
					if (targetText) {
						const newContent = tempDivText.querySelector(`[data-xpath="${patch.xpath}"]`);
						if (newContent) {
							targetText.replaceWith(newContent.cloneNode(true)); // Заменяем весь блок
						}
					}

					//console.log(patch.value);
					break;

					
				/*case 'update-attr':
					nodes.forEach(node => {
						node.setAttribute(patch.name, patch.value);
					});
					break;*/
			}
		}

		// Создаём временный контейнер для рендеринга
		const tempContainer = document.createElement('div');
		
		// Рендерим ТОЛЬКО изменённую часть через XSLT
		await this.renderFragment(
			id,
			tempContainer,
			clonedXml,
			patches
		);

		// Синхронизируем с основным DOM
		this._syncDomChanges(id, tempContainer);
	}

	_getParentXPath(node) {
		return this._getXPath(node.parentElement);
	}

	/**
	 * Создаёт XML на основе XPath и значения, сохраняя атрибуты корневого элемента <module>.
	 * @param {string} xpath - XPath, который нужно использовать для создания XML.
	 * @param {string} value - Значение, которое нужно вставить в XML.
	 * @param {Document} sourceXml - Исходный XML, из которого берутся атрибуты <module>.
	 * @returns {string} - Строка с XML.
	 */
	_createXmlFromXPath(xpath, value, sourceXml) {
		// Извлекаем атрибуты корневого элемента <module>
		const moduleElement = sourceXml.documentElement;
		const moduleAttributes = Array.from(moduleElement.attributes)
			.map(attr => `${attr.name}="${attr.value}"`)
			.join(' ');

		// Разбиваем XPath на части
		const parts = xpath.split('/').filter(part => part.trim() !== '');

		// Убедимся, что первый элемент — это "module"
		if (parts[0] !== 'module') {
			throw new Error('XPath должен начинаться с /module');
		}

		// Убираем "module" из частей, так как он будет корневым элементом
		parts.shift();

		// Создаём XML с учётом структуры XPath
		let xml = `<module ${moduleAttributes}>`;
		let currentPath = '';

		// Открываем все промежуточные теги
		parts.forEach((part, index) => {
			currentPath += `/${part}`;

			// Обрабатываем часть XPath (убираем индексы и атрибуты)
			const { tagName, attributes } = this._parseXPathPart(part);

			// Создаём открывающий тег
			xml += `<${tagName}`;

			// Добавляем атрибуты, если они есть
			if (attributes) {
				for (const [name, value] of Object.entries(attributes)) {
					xml += ` ${name}="${value}"`;
				}
			}

			xml += `>`;

			// Если это последний элемент, вставляем значение
			if (index === parts.length - 1) {
				xml += `${value}`;
			}
		});

		// Закрываем все промежуточные теги
		for (let i = parts.length - 1; i >= 0; i--) {
			const { tagName } = this._parseXPathPart(parts[i]);
			xml += `</${tagName}>`;
		}

		xml += `</module>`;

		return xml;
	}

	/**
	 * Разбирает часть XPath (например, "page[4]" или "item[@id='42']").
	 * @param {string} part - Часть XPath.
	 * @returns {Object} - Объект с именем тега и атрибутами.
	 */
	_parseXPathPart(part) {
		// Регулярное выражение для извлечения имени тега и атрибутов
		const tagRegex = /^([^\[]+)(?:\[([^\]]+)\])?$/;
		const match = part.match(tagRegex);

		if (!match) {
			throw new Error(`Некорректная часть XPath: ${part}`);
		}

		const tagName = match[1]; // Имя тега
		const attrString = match[2]; // Строка с атрибутами (если есть)

		// Парсим атрибуты
		let attributes = null;
		if (attrString) {
			attributes = {};
			const attrRegex = /@(\w+)='([^']*)'/g;
			let attrMatch;
			while ((attrMatch = attrRegex.exec(attrString)) !== null) {
				attributes[attrMatch[1]] = attrMatch[2];
			}
		}

		return { tagName, attributes };
	}

	_syncDomChanges(id, tempContainer) {
		const component = this.components.get(id);
		//if (!component) return;

		const { state, templateId, container } = component;

		// Находим все изменённые узлы во временном контейнере
		const changedNodes = tempContainer.querySelectorAll('[data-diff-marker]');

		changedNodes.forEach(tempNode => {
			const xpath = tempNode.dataset.xpath;
			const existingNode = container.querySelector(`[data-xpath="${xpath}"]`);

			if (!existingNode) {
				// Вставка нового узла
				const parentXpath = this._getParentXPath(tempNode);
				const parentNode = container.querySelector(`[data-xpath="${parentXpath}"]`);
				
				if (parentNode) {
					const clone = tempNode.cloneNode(true);
					clone.removeAttribute('data-diff-marker');
					parentNode.appendChild(clone);
					
					// Добавляем класс с анимацией
					//clone.classList.add('fade-in');
				}
			} else if (!tempNode.isEqualNode(existingNode)) {
				// Обновление существующего узла
				const clone = tempNode.cloneNode(true);
				clone.removeAttribute('data-diff-marker');
				existingNode.parentNode.replaceChild(clone, existingNode);
			}
		});
	}

	_evaluateXPath(xpath, doc) {
		const result = doc.evaluate(
			xpath,
			doc,
			null,
			XPathResult.ORDERED_NODE_SNAPSHOT_TYPE,
			null
		);
		
		const nodes = [];
		for(let i = 0; i < result.snapshotLength; i++) {
			nodes.push(result.snapshotItem(i));
		}
		return nodes;
	}

	detachComponent(id) {
		const component = this.components.get(id);
		if (!component) return;

		// Очищаем контейнер компонента
		if (component.container) {
			component.container.innerHTML = '';
		}

		// Удаляем компонент из хранилища
		this.components.delete(id);
	}
}